// `label` holds an i18n key (under `adminUi`); render with the `translate` pipe.
// `value`/`symbol` are stable identifiers and must not be translated.
export const CURRENCIES = [
  { value: 'USD', label: 'adminUi.currencyUsd', symbol: '$' },
  { value: 'GBP', label: 'adminUi.currencyGbp', symbol: '£' },
  { value: 'SGD', label: 'adminUi.currencySgd', symbol: 'S$' },
  { value: 'CAD', label: 'adminUi.currencyCad', symbol: 'CA$' },
  { value: 'AUD', label: 'adminUi.currencyAud', symbol: 'A$' },
  { value: 'HKD', label: 'adminUi.currencyHkd', symbol: 'HK$' },
  { value: 'INR', label: 'adminUi.currencyInr', symbol: '₹' },
  { value: 'EUR', label: 'adminUi.currencyEur', symbol: '€' },
  { value: 'NIS', label: 'adminUi.currencyNis', symbol: '₪' },
] as const;

// `en-IN` / `en-GB` in the Generate Payment Code dropdown are MARKETS, NOT extra
// app languages: each keeps the /en URL segment and the 'en' language, and adds a
// ?region= signal to the generated link (in -> DMRA-safe en-IN.json; gb -> the
// British en-GB.json). The dialog maps en-IN -> language:'en'+market:'IN'+INR and
// en-GB -> language:'en'+market:'GB'+GBP before sending it to the server.
export const LANGUAGES = [
  { value: 'en', label: 'adminUi.languageEnglish' },
  { value: 'he', label: 'adminUi.languageHebrew' },
  { value: 'en-IN', label: 'adminUi.languageEnglishIndia' },
  { value: 'en-GB', label: 'adminUi.languageEnglishUk' },
] as const;

export function getCurrencySymbol(currencyValue: string): string {
  return CURRENCIES.find((c) => c.value === currencyValue)?.symbol ?? '$';
}
